module.exports = function() {
  return new Worker(__webpack_public_path__ + "1455c3b8ea22e04c4e26.worker.js");
};